export default class CoreEnvironmentHelper {
}
CoreEnvironmentHelper.environmentName = undefined;
CoreEnvironmentHelper.bmId = undefined;
CoreEnvironmentHelper.productCatalogOptimizationToggle = false;
CoreEnvironmentHelper.reducingNumbersOfProductCatalogCalls = false;
CoreEnvironmentHelper.priceRulesJSONDataOptimization = false;
